export default __webpack_public_path__ + "static/topmenu03@2x-37c0c445ceac1f6284d4efd62957f733.png";